import { render, staticRenderFns } from "./CourseDropDown.vue?vue&type=template&id=24fd1541&"
import script from "./CourseDropDown.vue?vue&type=script&lang=js&"
export * from "./CourseDropDown.vue?vue&type=script&lang=js&"
import style0 from "./CourseDropDown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports